import { EndpointConfig } from '@models/common.model';

export const EndPoint: EndpointConfig = {
  userStatisticSummary: {
    path: '/N081',
  },
  userStatisticDetail: {
    path: '/N082',
  },
  userRewardHistories: {
    path: '/N092',
  },
  userGrossIncomes: {
    path: '/N093',
  },
  userCancelOrder: {
    path: '/N10/cancel-order',
  },
  userInfo: {
    path: '/auth/me',
  },
  searchProduct: {
    path: '/N06/products',
  },
  product: {
    path: '/N06/products',
  },
  statisticsOverview: {
    path: '/statistics/overview',
  },
  statisticsCommission: {
    path: '/statistics/commission',
  },
  statisticsPersonalSale: {
    path: '/statistics/personal-sales',
  },
  cart: {
    path: '/N15',
  },
  updateCartItemQuantity: {
    path: '/N15/change',
  },
  userOrders: {
    path: '/N10/orders/user',
  },
  updateOrderEvidence: {
    path: '/N10/orders/evidence',
  },
  orders: {
    path: '/N10/orders',
  },
  cancelOrder: {
    path: '/N10/orders/cancel',
  },
  bank: {
    path: '/N05/banks',
  },
  uploadFile: {
    path: '/files/upload',
  },
  changeAvatar: {
    path: '/common/change-avatar',
  },
  changeBanner: {
    path: '/common/change-banner',
  },
  updateProfile: {
    path: '/user',
  },
  changePassword: {
    path: '/common/change-password',
  },
  agencyList: {
    path: '/N082',
  },
  personalSaleList: {
    path: '/N093',
  },
  commissionList: {
    path: '/N091',
  },
  homepage: {
    path: '/N06/products/homepage',
  },
  feedback: {
    path: '/feedback',
  },
  nutrishopProfile: {
    path: '/nutridayshop/profile',
  },
  nutrishopProduct: {
    path: '/nutridayshop/product',
  },
  nutrishopMe: {
    path: '/nutridayshop/me',
  },
  userWallet: {
    path: '/consumer-wallet',
  },
  nutrishopOrders: {
    path: '/nutridayshop/order',
  },
  nutrishopOrderApprove: {
    path: '/nutridayshop/order/approve',
  },
  searchUser: {
    path: '/common/search/all',
  },
  flashSale: {
    path: '/flashsale',
  },
  productCategories: {
    path: '/N06/categories',
  },
  proxyOrder: {
    path: '/N10/orders/shop',
  },
  downloadQR: {
    path: '/bot/qr',
  },
  searchNutridayShop: {
    path: '/common/search/shop/profile',
  },
  statisticDeptResolve: {
    path: '/n23/n234',
  },
  statisticDeptPending: {
    path: '/n23/n231',
  },
  statisticDeptDetail: {
    path: '/n23/n231',
  },
  statisticDeptUpload: {
    path: '/n23/upload',
  },
  statisticDeptDownload: {
    path: '/n23/download',
  },
  updateRegion: {
    path: '/N19/update',
  },
  notification: {
    path: '/notification',
  },
  readNotification: {
    path: '/notification/read',
  },
  readAllNotification: {
    path: '/notification/read/all',
  },
  orderDetail: {
    path: '/N07/orders',
  },
  botImageUpdate: {
    path: '/bot/upload',
  },
  countOrder: {
    path: '/N10/orders/count',
  },
  productRelevant: {
    path: '/N06/products/relevant',
  },
  cartCheck: {
    path: '/N15/check',
  },
  login: {
    path: '/auth/login',
  },
  createProduct: {
    path: '/N06/products/shop',
  },
  banners: {
    path: '/nutripage/content',
  },
};
